<style type="text/css">
  .c-alert {
  }

</style>

<template>
  <div v-if="dataShow" class="c-alert animated fadeIn">
    <b-alert show :variant="dataVariant">
      <div v-html="dataMessage"></div>
    </b-alert>
  </div>
</template>

<script>
  export default {
    name: 'Alert',
    components: {
    },
    props: {
      alert: {
        type: Object,
        default: function() {
          return {
            variant: 'danger',
            show: false,
            message: ''
          }
        }
      },
    },
    watch: {
      alert: {
        handler(val) {
          this.setData(val)
        },
        deep: true
      }
    },
    mounted() {
      this.setData(this.alert)
    },
    data: () => {
      return {
        dataVariant: '',
        dataMessage: '',
        dataShow: false
      }
    },
    methods: {
      setData(alert) {
        let variant = 'danger'
        let show = false
        let message = ''
        if (alert.variant !== undefined) {
          variant = alert.variant
        }
        if (alert.show !== undefined) {
          show = alert.show
        }
        if (alert.message !== undefined) {
          message = alert.message
        }
        this.dataVariant = variant
        this.dataShow = show
        this.dataMessage = message
      }
    }
  }
</script>
